function submitDynamicForm(path, params, method) {
  method = method || 'post';
  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);
  Object.keys(params).forEach(key => {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);
  form.submit();
}
export default submitDynamicForm;